import React from 'react';

const Certification = (props) => {
  const { rds, rsd, grs, treatment, brandName, t, changeWord } = props;
  const isRDS = !!rds;
  const isRSD = !!rsd;
  const isGRS = !!grs;
  const isTreatment = treatment && treatment.length > 0 && !!treatment[0] && (treatment[0] !== "None" && treatment[0] !== "none");

  const getLabel = () => {
    if (isGRS) {
      return isTreatment ? t("certs.grs_bluesign") : t("certs.grs_oeko");
    }
    if (isRSD) {
      if (isRDS || isTreatment) return t("certs.rsd");
      return t("certs.rsd_oeko");
    }
    if (isRDS) {
      return isTreatment ? t("certs.rds") : t("certs.rds_oeko");
    }
    return "bluesign® / OEKO-TEX® Standard 100";
  };

  const label = getLabel();

  return (
    <div className="content-ac cr hide">
      <input
        className="ac-input top"
        id="ac-9afd"
        name="ac-9afd"
        data-id="2400"
        data-slug="CERTIFICATIONS"
        type="checkbox"
        onChange={() => changeWord('certs clicked')}
      />
      <label className="ac-label" htmlFor="ac-9afd">
        {label}
      </label>
      <article className="ac-text ac-9afd">
        <div className="single-post-interior" tabIndex="0">
          
          {isRSD && (
            <div className="rds-desc">
              <p>{t("certs.rsd_p1", { brandName })}</p>
            </div>
          )}

          {isRDS && (
            <div className="rds-desc">
              <p>{t("certs.rds_title")}</p>
              <p>{t("certs.rds_p1")}</p>
              <p dangerouslySetInnerHTML={{ __html: t("certs.rds_p2") }} />
              <p>{t("certs.rds_p3")}</p>
            </div>
          )}

          {isGRS && (
            <div className="rds-desc">
              <p>{t("certs.grs_title")}</p>
              <p>{t("certs.grs_p1")}</p>
              <p>{t("certs.grs_p2")}</p>
            </div>
          )}
          
          <div className="blue-desc">
            <p>{t("certs.blue_title")}</p>
            <p dangerouslySetInnerHTML={{ __html: t("certs.blue_p1") }} />
          </div>
          
          {!isTreatment && (
            <div className="oeko-desc">
              <p>{t("certs.oeko_title")}</p>
              <p>{t("certs.oeko_p1")}</p>
            </div>
          )}
        </div>
        <footer></footer>
      </article>
    </div>
  );
}

export default Certification;
